export const RegexPatterns = {
    EMAIL: '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$',
    PASSWORD: '^(?=.*[A-Z])(?=.*[a-z])(?=.*\\d)(?=.*[!"#$%&\'()*+,\\-./:;<=>?@[\\]^_`{|}~])[A-Za-z\\d!"#$%&\'()*+,\\-./:;<=>?@[\\]^_`{|}~]{8,}$',
    NUMBER: '^[0-9]*$',
    ICC: '^(89)(\\d)(\\d{3})(\\d{13})(\\d)$',
    DOUBLE: '^(-?)(0|([1-9][0-9]*))(\\.[0-9]+)?$'
};
